var remixLib = require('@remix-project/remix-lib')
var EventManager = remixLib.EventManager

module.exports = EventManager
